import { useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { LibraryItem } from '@/api/types'
import type { QueueItem } from '@/audio/store'

export function useCurrentSong(item: QueueItem, active: boolean) {
  const client = useQueryClient()
  const queryKey = ['library', 'item', item.libraryItemId]
  const query = useQuery({ queryKey, enabled: active,
    queryFn: ({ signal }) => api.get<LibraryItem>(`/library/tracks/${item.libraryItemId}`, undefined, signal),
  })
  return { ...query, update: (song: LibraryItem) => client.setQueryData(queryKey, song) }
}
